import * as React from 'react';

export interface IABCallButtonProps {
  isFromBuilder: boolean;
}

export const ABCallButtonComponent = (props: IABCallButtonProps) => {
  const { isFromBuilder } = props;
  let text;

  if (isFromBuilder) {
    text = 'Контакты застройщика';
  } else {
    text = 'Показать телефон';
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{text}</>;
};
